import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Billing from "../../../containers/modules/sales/billing";
import ReturnPrice from "../../../containers/modules/sales/return-price";

export default function ReturnPriceRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="return-price"
      index
    element={
    <AccessControl
        name={"Return Price List"}
        auth={authUser}
        component={() => <ReturnPrice />}
    />
    }
    />
  );
}
